import React from 'react';

import { makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { DTRRule } from '../types';

import CustomDrawer from 'components/shared/Drawer/Drawer';

import { DTRRuleDataLoaderFeedback } from './DTRRuleDataLoaderFeedback';

const useStyles = makeStyles(() => ({
  customDrawer: {
    width: '450px'
  }
}));

interface Props {
  open: boolean;
  onClose: () => void;
  selectedRow: DTRRule;
}

export const EditDTRRuleDrawer: React.FC<Props> = ({
  open,
  onClose,
  selectedRow
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <CustomDrawer
      classes={{
        paper: classes.customDrawer
      }}
      title={t('dtrRules.drawer.title')}
      anchor="right"
      open={open}
      onClose={onClose}
    >
      <DTRRuleDataLoaderFeedback selectedRow={selectedRow} onClose={onClose} />
    </CustomDrawer>
  );
};
